export default __webpack_public_path__ + "static/media/d668f1f31bba6bcbb6d5b8ebf79208eb.svg";